const tags = {
  "tag.all": "Todos",
  "tag.drill": "Ejercicios",
  "tag.bronze_league": "Liga Bronce",
  "tag.silver_league": "Liga Plata",
  "tag.gold_league": "Liga Oro",
  "tag.champions_league": "Liga de Campeones",
  "tag.bootcamp": "Bootcamp",
  "tag.qa": "QA",
  "tag.development": "En desarrollo",
  "tag.beta_content": "Contenido Beta",
  "tag.demo": "Prueba",
};

export default tags;
